import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    width: 100%;
    min-height: 40px;
    align-items: center;
    padding: 0 0.5rem 0 0.5rem ;
    justify-content: space-between;
    border-radius: 6px;
    background-color: #f6f6f6;
    border: 1px solid #dfe0e1;

    .prev--{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.75rem;
    }

    .linkedInitial{
        width: 150px;
        text-align: center;
    }
`;